import { Component, Prop, Vue } from 'vue-property-decorator';
import { RewardRequestDTO } from '@/models';
import { formatDateToDisplay } from '@/helpers';
import { DEFAULT_DISPLAY_VALUE, REWARD_REQUEST_STATUSES } from '@/constants';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';

interface TooltipInformation {
  content: string;
  icon: string;
  iconColor: string;
}

@Component({
  components: {
    Tooltip
  }
})
export default class ExchangeItem extends Vue {
  @Prop({ default: {} as RewardRequestDTO }) private exchange: RewardRequestDTO;
  private imageUrl = process.env.VUE_APP_HIVE_HOME_URL + '/images/';

  get displayDate(): string {
    if (this.exchange?.updatedAt) {
      return formatDateToDisplay(this.exchange?.updatedAt);
    }
    return DEFAULT_DISPLAY_VALUE.DATE;
  }

  isSuccess(): boolean {
    return this.exchange.status === REWARD_REQUEST_STATUSES.APPROVED.label;
  }

  isError(): boolean {
    return this.exchange.status === REWARD_REQUEST_STATUSES.REJECTED.label;
  }

  isPending(): boolean {
    return this.exchange.status === REWARD_REQUEST_STATUSES.PENDING.label;
  }

  isProcessing(): boolean {
    return this.exchange.status === REWARD_REQUEST_STATUSES.IN_PROGRESS.label;
  }

  getImageSource(imgStr: string): string {
    return this.imageUrl + imgStr;
  }

  get statusTooltipInformation(): TooltipInformation {
    //success
    if (this.isSuccess()) {
      return {
        content: 'Successfully redeem this item',
        icon: 'mdi-checkbox-marked-circle',
        iconColor: 'success'
      };
    }
    //error
    return {
      content: this.exchange.reason,
      icon: 'mdi-alert-circle',
      iconColor: 'error'
    };
  }

  get actionTooltipInformation(): TooltipInformation {
    //processing
    if (this.isProcessing()) {
      return {
        content: "Confirm that you've claimed this item",
        icon: 'mdi-check',
        iconColor: 'icon-green'
      };
    }
    //pending
    return {
      content: 'Cancel',
      icon: 'mdi-close',
      iconColor: 'icon-red'
    };
  }

  get isStatusTooltipShown(): boolean {
    return this.isSuccess() || this.isError();
  }

  get isActionTooltipShown(): boolean {
    return this.isPending() || this.isProcessing();
  }

  onCancelRequest(item: RewardRequestDTO): void {
    this.$emit('onCancelRequest', item);
  }

  onApproveRequest(item: RewardRequestDTO): void {
    this.$emit('onApproveRequest', item);
  }

  onExchangeItemActionClicked(item: RewardRequestDTO): void {
    if (this.isPending()) {
      this.onCancelRequest(item);
    }
    if (this.isProcessing()) {
      this.onApproveRequest(item);
    }
  }

  get isShippingInfoTooltipShown(): boolean {
    return !!this.exchange?.note;
  }

  get shippingInfoTooltipInformation(): TooltipInformation {
    return {
      content: this.exchange.note || '',
      icon: 'mdi-map-marker',
      iconColor: 'amber'
    };
  }
}
